import React, { useState, useEffect, useRef } from "react";
import { Stepper, Step } from "react-form-stepper";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { MDBCarousel, MDBCarouselItem } from "mdb-react-ui-kit";

import "../../../../utils/Css/Marketing.css";
import "../../../../utils/Css/Campagne.css";
//Boostrap
import { Card, Button, ButtonGroup, Dropdown } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
// import Divider from "@material-ui/core/Divider";
//table
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";

//pagination
import paginationFactory from "react-bootstrap-table2-paginator";

const stepTitle = ["Creation", "Destinataires", "Date de l'envoi"];

function EditCampagneE() {
  //data-CampagneEmail
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    const data = [
      {
        id: "1",
        date: "2023-02-01",
        nom: "Haouari",
        prenom: "Siwar",
        numero: "25362158",
        age: "20",
        adresse: "Monastir",
        email: "haouarisiwar6@gmail.com",
      },
      {
        id: "2",
        date: "2023-02-01",
        nom: "Ben saleh",
        prenom: "Mohamed",
        numero: "50214789",
        age: "25",
        adresse: "Sousse",
        email: "haouarisiwar6@gmail.com",
      },
      {
        id: "3",
        date: "2023-02-01",
        nom: "ben Ali",
        prenom: "Ali",
        numero: "25369815",
        age: "23",
        adresse: "Tunis",
        email: "haouarisiwar6@gmail.com",
      },
      {
        id: "4",
        date: "2023-02-01",
        nom: "Ben sami",
        prenom: "Sami",
        numero: "32014569",
        age: "24",
        adresse: "Monastir",
        email: "haouarisiwar6@gmail.com",
      },
      {
        id: "5",
        date: "2023-02-01",
        nom: "Ben sami",
        prenom: "Sami",
        numero: "32014569",
        age: "24",
        adresse: "Monastir",
        email: "haouarisiwar6@gmail.com",
      },
      {
        id: "6",
        date: "2023-02-01",
        nom: "Ben sami",
        prenom: "Sami",
        numero: "32014569",
        age: "24",
        adresse: "Monastir",
        email: "haouarisiwar6@gmail.com",
      },
    ];

    setData(data);
  };

  // /.data-CampagneEmail

  //Date
  const [editing, setEditing] = useState(false);

  const handleDateClick = () => {
    setEditing(true);
  };

  const handleDateBlur = () => {
    setEditing(false);
  };
  const [dateTime, setDateTime] = useState(new Date());

  const handleDateTimeChange = (event) => {
    setDateTime(new Date(event.target.value));
  };

  // columns-CampagneEmail
  const columns = [
    {
      dataField: "nom",
      text: "Nom",
    },
    {
      dataField: "prenom",
      text: "Prenom",
    },
    {
      dataField: "numero",
      text: "Numero",
    },
    {
      dataField: "age",
      text: "Age",
    },
    {
      dataField: "adresse",
      text: "Adresse",
    },
  ];
  // /.columns-CampagneEmail

  //MultiSelect
  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
  };

  //pagination
  const options = {
    sizePerPage: 4,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  // route
  const navigate = useNavigate();

  //Stepper
  const [activeStep, setActiveStep] = useState(0);

  const handleNextStep = () => {
    setActiveStep(Math.min(activeStep + 1, 2));
  };
  const handleNextStepToFinal = () => {
    setActiveStep(Math.min(activeStep + 2, 2));
  };

  const handleBackStep = () => {
    setActiveStep(Math.max(activeStep - 1, 0));
  };
  const handleBackStepToStart = () => {
    setActiveStep(Math.max(activeStep - 2, 0));
  };

  const stepStyleConfig = {
    activeBgColor: "#848687",
    completedBgColor: "#333",
  };

  //condition sur radio button
  const [isImporting, setIsImporting] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const handleRadioChange = (event) => {
    if (event.target.value === "importer") {
      setIsImporting(true);
    } else {
      setIsImporting(false);
    }
  };

  const handleAttachmentChange = (event) => {
    setAttachment(event.target.files[0]);
  };

  return (
    <div>
      {/* content-header */}
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Campagne Email</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Marketing</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/Campagne">Campagne</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/Campagne/PageCampagneE">Email</a>
                  </li>
                  <li className="breadcrumb-item active">Modification</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}


        {/* content */}
        <section className="content mt-3">
          {/* container-fluid */}
          <div className="container-fluid">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">Modifier Campagne d'email</h3>
              </div>
              <div className="card-body">
                <Stepper styleConfig={stepStyleConfig} activeStep={activeStep}>
                  {stepTitle.map((title) => (
                    <Step key={title} label={title} />
                  ))}
                </Stepper>
                {activeStep === 0 ? (
                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label>Nom</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="Nom"
                        />
                      </div>
                      <div className="form-group">
                        <label>Objectif</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          placeholder="Objectif ..."
                        />
                      </div>
                      <div className="form-group">
                        <label>Sujet d'email</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="Sujet d'email"
                        />
                      </div>
                      <div className="form-group">
                        <label> Contenu d'email</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          placeholder="Contenu d'email ..."
                        />
                      </div>
                      <div className="form-group">
                        <label> Pieces joints</label>
                        <div className="input-group">
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="exampleInputFile"
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="exampleInputFile"
                            >
                              Choose file
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Clients</label>
                        <div className="custom-control custom-radio">
                          <input
                            className="custom-control-input custom-control-input-dark"
                            type="radio"
                            id="customRadio1"
                            name="customRadio"
                            value="liste"
                            checked={!isImporting}
                            onChange={handleRadioChange}
                          />
                          <label
                            htmlFor="customRadio1"
                            className="custom-control-label"
                          >
                            Liste
                          </label>
                        </div>
                        <div className="custom-control custom-radio">
                          <input
                            className="custom-control-input custom-control-input-dark"
                            type="radio"
                            id="customRadio2"
                            name="customRadio"
                            value="importer"
                            checked={isImporting}
                            onChange={handleRadioChange}
                          />
                          <label
                            htmlFor="customRadio2"
                            className="custom-control-label"
                          >
                            Importer fichier
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        {isImporting && (
                          <div className="input-group">
                            <div className="custom-file">
                              <input
                                type="file"
                                className="custom-file-input"
                                id="exampleInputFile"
                                onChange={handleAttachmentChange}
                              />
                              <label
                                className="custom-file-label"
                                htmlFor="exampleInputFile"
                              >
                                Importer fichier CSV
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
                {activeStep === 1 ? (
                  <ToolkitProvider keyField="id" data={data} columns={columns}>
                    {(props) => (
                      <>
                        <Card className="Campagne-card-buttons">
                          <Card.Body>
                            <div className="row">
                              <div className="col">
                                <Card
                                  style={{
                                    backgroundColor: "#848687",
                                    color: "white",
                                  }}
                                >
                                  <Card.Body>
                                    <div className="row">
                                      <div className="col-3 text-center">
                                        <label className="col">
                                          Destinataires
                                        </label>
                                        <label className="col">25</label>
                                      </div>
                                      <div className="col-8">
                                        <label className="col">Filtres</label>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </div>
                              <div className="w-100"></div>

                              <div className="col">
                                <div className="table-container thead-dark">
                                  <BootstrapTable
                                    keyField="id"
                                    {...props.baseProps}
                                    selectRow={selectRow}
                                    hover
                                    condensed
                                    pagination={paginationFactory(options)}
                                    defaultSorted={[
                                      { dataField: "date", order: "asc" },
                                    ]}
                                    defaultSortDirection="asc"
                                    noDataIndication={() => "No data found"}
                                    columns={columns}
                                    headerClasses="thead-dark"
                                  />
                                </div>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>

                        {/* /.table */}
                      </>
                    )}
                  </ToolkitProvider>
                ) : null}
                {activeStep === 2 ? (
                  <ToolkitProvider keyField="id" data={data} columns={columns}>
                    {(props) => (
                      <>
                        <Card className="Campagne-card-buttons">
                          <Card.Body>
                            <div className="row">
                              <div className="col">
                                <Card
                                  style={{
                                    backgroundColor: "#848687",
                                    color: "white",
                                  }}
                                >
                                  <Card.Body>
                                    <div className="row">
                                      <div className="col-3 text-center">
                                        <label className="col">Type</label>
                                        <label className="col">Email</label>
                                      </div>
                                      <div className="col-3 text-center">
                                        <label className="col">
                                          Destinataires
                                        </label>
                                        <label className="col">25</label>
                                      </div>

                                      <div className="col-3 text-center">
                                        <label className="col">
                                          Date de l'envoi
                                        </label>
                                        <label className="col">
                                          {editing ? (
                                            <input
                                              id="dateTime"
                                              type="datetime-local"
                                              value={dateTime
                                                .toISOString()
                                                .slice(0, -8)}
                                              onChange={handleDateTimeChange}
                                              onBlur={handleDateBlur}
                                            />
                                          ) : (
                                            <span onClick={handleDateClick}>
                                              {dateTime.toLocaleString(
                                                "fr-FR",
                                                {
                                                  year: "numeric",
                                                  month: "2-digit",
                                                  day: "2-digit",
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                }
                                              )}
                                            </span>
                                          )}
                                        </label>
                                      </div>

                                      <div className="col-3 text-center">
                                        <label className="col">Cout</label>
                                        <label className="col">0.15</label>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </div>
                              <div className="w-100"></div>

                              <div className="col">
                                <Card>
                                  <Card.Body>
                                    <div className="row">
                                      <h5 className="col-12 text-center font-weight">
                                        Aperçu de l'email envoyé aux 25
                                        destinataires
                                      </h5>
                                      <div className="col-12 text-center text-muted">
                                        <small>
                                          Cet aperçu est affiché à titre
                                          indicatif, le résultat final peut être
                                          différent
                                        </small>
                                      </div>

                                      <div className="container mt-3">
                                        <div className="row">
                                          <div className="col-sm"></div>
                                          <div className="col-sm">
                                            <div className="row">
                                              <div className="col-2">
                                                <label>Sujet : </label>
                                              </div>
                                              <div className="col font-italic">
                                                <div>Remise Produits </div>
                                              </div>
                                            </div>
                                            <div className="row">
                                              <div className="col">
                                                <label>Contenu :</label>
                                              </div>
                                              <div className="w-100"></div>

                                              <div className="col">
                                                <div>
                                                  Lorem Ipsum is simply dummy
                                                  text of the printing and
                                                  typesetting industry. Lorem
                                                  Ipsum has been the industry's
                                                  standard dummy text ever since
                                                  the 1500s.
                                                </div>
                                              </div>
                                            </div>

                                            <MDBCarousel
                                              showIndicators
                                              showControls={false}
                                              className="mt-3"
                                            >
                                              <MDBCarouselItem
                                                className="w-100 d-block"
                                                itemId={1}
                                                src="https://mdbootstrap.com/img/new/slides/041.jpg"
                                                alt="..."
                                              />
                                              <MDBCarouselItem
                                                className="w-100 d-block"
                                                itemId={2}
                                                src="https://mdbootstrap.com/img/new/slides/042.jpg"
                                                alt="..."
                                              />
                                              <MDBCarouselItem
                                                className="w-100 d-block"
                                                itemId={3}
                                                src="https://mdbootstrap.com/img/new/slides/043.jpg"
                                                alt="..."
                                              />
                                            </MDBCarousel>
                                          </div>
                                          <div className="col-sm"></div>
                                        </div>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                        {/* /.table */}
                      </>
                    )}
                  </ToolkitProvider>
                ) : null}
              </div>

              <div className="card-footer">
                <div className="row">
                  <div className="col">
                    {/* condition sur lsuivant et precedent */}
                    <FaChevronLeft
                      onClick={
                        isImporting ? handleBackStepToStart : handleBackStep
                      }
                    />
                    <FaChevronRight
                      onClick={
                        isImporting ? handleNextStepToFinal : handleNextStep
                      }
                    />
                  </div>

                  {/* condition sur les button modifier + annuler */}
                  <div className="col text-right" style={{ width: "100%" }}>
                    <Button
                      className="btn btn-secondary mr-2"
                      onClick={() => navigate("/Campagne/PageCampagneE")}
                      style={{ width: "150px" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      className="btn btn-dark"
                      disabled={activeStep !== 2}
                      style={{ width: "150px" }}
                    >
                      Modifier
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
      </div>
    </div>
  );
}

export default EditCampagneE;
